import { render, staticRenderFns } from "./ScreenExcluir.vue?vue&type=template&id=6478b45a"
import script from "./ScreenExcluir.vue?vue&type=script&lang=js"
export * from "./ScreenExcluir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports